<template>
  <div>
    <div class="wrapper">
      <breadcrumb
        :crumbs="[$t('menu.stockIns'), $t('text.count')]"
      ></breadcrumb>
    </div>
    <div class="wrapper table-area">
      <vxe-table
        :data="datas"
        id="datasTable"
        row-id="id"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        resizable
        round
        auto-resize
        　highlight-hover-row
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column field="name" :title="$t('text.time')">
          <template v-slot="{ row }">{{ $t("countDay." + row.name) }}</template>
        </vxe-table-column>
        <vxe-table-column
          field="productNoCount"
          :title="$t('stock.productNoQty')"
        >
          <template v-slot="{ row }">
            <router-link
              :to="{ name: 'wmsStockIns', query: { initFilter: row.name } }"
              >{{ row.productNoCount }}</router-link
            >
          </template>
        </vxe-table-column>
        <vxe-table-column field="quantity" :title="$t('stock.productAmount')">
          <template v-slot="{ row }">
            <router-link
              :to="{ name: 'wmsStockIns', query: { initFilter: row.name } }"
              >{{ row.quantity }}</router-link
            >
          </template>
        </vxe-table-column>
      </vxe-table>
      <div
        class="center blue"
        style="height: 60px; line-height: 60px"
        @click="$router.push('/normal/wms/stock-ins')"
      >
        {{ $t("stock.viewStockInOutDetail") }}
      </div>
    </div>
  </div>
</template>
<script>
import { page } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import StockInOut from "@/api/stockInOut.js";

export default {
  mixins: [page],
  components: {},
  data() {
    return {
      Util: Util,
      datas: [],
    };
  },
  created() {
    const self = this;
    self.loadingStart();
    StockInOut.count({ stockType: "in" }).then(function (res) {
      if (res.status === 200) {
        self.datas = res.data;
      } else {
        self.sysError();
      }
      self.loadingEnd();
    });
  },
  methods: {},
};
</script>
